module.exports = __webpack_public_path__ + "img/枣强皮毛玻璃钢.9cb42349.jpg";